// Macht aus jeder API-Antwort einen anzeigbaren Text (FastAPI liefert bei 422 eine Liste von Objekten)
export const fehlerText = (err, fallback = "Das hat nicht funktioniert") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail) && detail.length) {
    const feld = (detail[0].loc || []).filter((l) => l !== "body").join(" / ");
    return `${feld ? feld + ": " : ""}${detail[0].msg || "Ungültige Eingabe"}`;
  }
  if (detail && typeof detail === "object" && detail.msg) return detail.msg;
  return err?.message ? `${fallback} (${err.message})` : fallback;
};
